import { Link } from "react-router-dom";
import CITIES from "@/data/loiret-cities";
import PARIS_CITIES from "@/data/paris-cities";

const PARIS_SERVICES = [
    { to: "/serrurier-paris", label: "Serrurier Paris" },
    { to: "/ouverture-porte-paris", label: "Ouverture de porte Paris" },
    { to: "/changement-serrure-paris", label: "Changement de serrure Paris" },
    { to: "/depannage-serrurier-paris", label: "Dépannage serrurier Paris" },
    { to: "/artisan-serrurier-paris", label: "Artisan serrurier Paris" },
    { to: "/urgence-serrurier-paris", label: "Urgence serrurier Paris" },
    { to: "/serrurier-charenton-le-pont-94", label: "Serrurier Charenton-le-Pont" },
];

const SITE_PAGES = [
    { to: "/", label: "Accueil" },
    { to: "/ouverture-de-porte", label: "Ouverture de porte" },
    { to: "/depannage-serrurier", label: "Dépannage serrurier" },
    { to: "/remplacement-serrure", label: "Remplacement de serrure" },
    { to: "/faq", label: "FAQ" },
    { to: "/contact", label: "Devis gratuit" },
];

const LinkGroup = ({ title, links, currentPath }) => (
    <div>
        <div className="text-[10px] uppercase tracking-[0.22em] font-semibold text-zinc-500 mb-3">{title}</div>
        <ul className="flex flex-wrap gap-x-4 gap-y-2">
            {links.map((l) =>
                l.to === currentPath ? null : (
                    <li key={l.to}>
                        <Link
                            to={l.to}
                            className="text-xs text-zinc-400 hover:text-white transition-colors"
                            data-testid={`zones-footer-link${l.to.replace(/\//g, "-")}`}
                        >
                            {l.label}
                        </Link>
                    </li>
                )
            )}
        </ul>
    </div>
);

const SeoZonesFooter = ({ region, currentPath }) => {
    const arrondissements = PARIS_CITIES.filter((c) => c.n).map((c) => ({ to: `/${c.slug}`, label: c.name }));
    const loiretCities = [
        { to: "/serrurier-orleans-45", label: "Orléans" },
        ...CITIES.map((c) => ({ to: `/serrurier-${c.slug}-45`, label: c.name })),
    ];
    const crossParis = [
        { to: "/serrurier-paris", label: "Serrurier Paris" },
        { to: "/serrurier-charenton-le-pont-94", label: "Serrurier Charenton-le-Pont" },
    ];
    const crossLoiret = [
        { to: "/serrurier-orleans-45", label: "Serrurier Orléans" },
        { to: "/serrurier-montargis-45", label: "Serrurier Montargis" },
        { to: "/serrurier-gien-45", label: "Serrurier Gien" },
    ];

    return (
        <section className="bg-[#0A0A0A] border-t border-white/10" data-testid="seo-zones-footer">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-8">
                <div className="text-xs uppercase tracking-[0.22em] font-semibold text-[#E63946]">◉ Zones d'intervention Atelier Beauchamp</div>
                {region === "paris" ? (
                    <>
                        <LinkGroup title="Serrurier Paris — nos services" links={PARIS_SERVICES} currentPath={currentPath} />
                        <LinkGroup title="Serrurier par arrondissement" links={arrondissements} currentPath={currentPath} />
                        <LinkGroup title="Aussi dans le Loiret (45)" links={crossLoiret} currentPath={currentPath} />
                    </>
                ) : (
                    <>
                        <LinkGroup title="Serrurier dans le Loiret (45)" links={loiretCities} currentPath={currentPath} />
                        <LinkGroup title="Aussi à Paris & Val-de-Marne" links={crossParis} currentPath={currentPath} />
                    </>
                )}
                <LinkGroup title="Atelier Beauchamp" links={SITE_PAGES} currentPath={currentPath} />
            </div>
        </section>
    );
};

export default SeoZonesFooter;
